import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=c47c312c&scoped=true&"
import script from "./ComparisonCard.vue?vue&type=script&lang=js&"
export * from "./ComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=c47c312c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47c312c",
  null
  
)

export default component.exports